module.exports = __webpack_public_path__ + "img/tobuf_btn.9c6c8b86.png";